import { useEffect, useState } from "react";
import CountUp from "react-countup";
import { getAll } from "../../api/API";
import "../../styles/HeroStats.css";

// format large numbers
const formatStat = (value) => {
  if (value >= 1_000_000) return { display: value / 1_000_000, suffix: "M+" };
  if (value >= 1_000) return { display: value / 1_000, suffix: "K+" };
  return { display: value, suffix: "+" };
};

const CACHE_KEY = "dashboardStats";
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const HeroStats = () => {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    const cached = sessionStorage.getItem(CACHE_KEY);

    if (cached) {
      const { data, timestamp } = JSON.parse(cached);

      if (Date.now() - timestamp < CACHE_TTL) {
        setStats(data);
        return;
      }
    }

    const fetchStats = async () => {
      try {
        const data = await getAll("/dashboard-stats");

        const formatted = [
          { label: "Members", value: data?.Members ?? 0 },
          { label: "Mentors", value: data?.Mentors ?? 0 },
          { label: "Events", value: data?.Events ?? 0 },
          { label: "Blogs", value: data?.["Blog Posts"] ?? 0 },
        ];

        setStats(formatted);

        sessionStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ data: formatted, timestamp: Date.now() }),
        );
      } catch (err) {
        console.error("HeroStats error:", err);
      }
    };

    fetchStats();
  }, []);

  return (
    <section className="hero-stats-section">
      <div className="bg-primary stats-card">
        {stats.map((stat, i) => {
          const { display, suffix } = formatStat(stat.value);

          return (
            <div key={i} className="stat-item">
              <h3
                className="text-secondary stat-value"
                title={stat.value.toLocaleString()}
              >
                <CountUp
                  end={display}
                  duration={1.6}
                  decimals={display < 10 && display % 1 !== 0 ? 1 : 0}
                  suffix={suffix}
                />
              </h3>
              <p className="text-secondary stat-label">{stat.label}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HeroStats;
